import { useEffect, useState } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { supabase } from "../../lib/supabase";

const iso = (d) => d.toISOString().slice(0, 10);
const SERIES = [
  { key: "registrations", label: "Registrations", color: "#7A0016" },
  { key: "logins", label: "Logins", color: "#C59B27" },
  { key: "shares", label: "Profiles shared", color: "#2F6B4F" },
  { key: "responses", label: "Client responses", color: "#8C6A6C" },
];

export function ActivityChart() {
  const [from, setFrom] = useState(iso(new Date(Date.now() - 29 * 864e5)));
  const [to, setTo] = useState(iso(new Date()));
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!from || !to) return;
    supabase.rpc("admin_activity_series", { p_from: from, p_to: to }).then(({ data, error }) => {
      if (error) toast.error(error.message);
      else setRows(data.map((r) => ({ ...r, label: r.day.slice(5) })));
    });
  }, [from, to]);
  return (
    <section data-testid="activity-chart" className="rmm-card p-5 sm:p-6">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <h2 className="font-display text-2xl font-semibold text-[#7A0016]">Activity</h2>
        <div className="flex items-end gap-2 text-xs text-[#8C6A6C]">
          <label className="space-y-1">From<Input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} data-testid="activity-from" className="rmm-input h-9 bg-white" /></label>
          <label className="space-y-1">To<Input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} data-testid="activity-to" className="rmm-input h-9 bg-white" /></label>
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F4EFEA" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend />
            {SERIES.map((s) => <Line key={s.key} type="monotone" dataKey={s.key} name={s.label} stroke={s.color} strokeWidth={2} dot={false} />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
